// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3_15g","content":"RecentSearches_content__3ucxH"};